import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { forAreaRugs } from '../forAreaRugs';
import { MeasurementGuideContent } from './MeasurementGuideContent';

export const MeasurementGuideMobile = forAreaRugs(withDynamicComponent(
  withHydrator({
    id: 'product-section-mg',
    className: 'grid',
    delay: 1500,
    scrollBuffer: 50,
    preserveCtxVal: 'clientStore',
  }, MeasurementGuideContent),
  { pageType: 'pip' }));

MeasurementGuideMobile.displayName = 'MeasurementGuideMobile';
